module.exports = __webpack_public_path__ + "img/9Creators2.27df6111.png";